type MaterialStep = 50 | 100 | 200 | 300 | 400 | 500 | 600 | 700 | 800 | 900;

const RED: ReadonlyMap<MaterialStep, string> = new Map([
  [50, '#FFE8EF'],
  [100, '#FFC9D2'],
  [200, '#FA9498'],
  [300, '#F06D73'],
  [400, '#FC4A4F'],
  [500, '#FF3535'],
  [600, '#EF2A34'],
  [700, '#DC192E'],
  [800, '#D01227'],
  [900, '#C10019'],
]);

const PINK: ReadonlyMap<MaterialStep, string> = new Map([
  [50, '#fce4ec'],
  [100, '#f8bbd0'],
  [200, '#f48fb1'],
  [300, '#f06292'],
  [400, '#ec407a'],
  [500, '#e91e63'],
  [600, '#d81b60'],
  [700, '#c2185b'],
  [800, '#ad1457'],
  [900, '#880e4f'],
]);

const PURPLE: ReadonlyMap<MaterialStep, string> = new Map([
  [50, '#FFFFFF'],
  [100, '#FFEEFF'],
  [200, '#EFC4FF'],
  [300, '#D098FF'],
  [400, '#B977FF'],
  [500, '#A556FF'],
  [600, '#9B53FB'],
  [700, '#8F48EF'],
  [800, '#8242E8'],
  [900, '#6B34D9'],
]);

const DEEP_PURPLE: ReadonlyMap<MaterialStep, string> = new Map([
  [50, '#ede7f6'],
  [100, '#d1c4e9'],
  [200, '#b39ddb'],
  [300, '#9575cd'],
  [400, '#7e57c2'],
  [500, '#673ab7'],
  [600, '#5e35b1'],
  [700, '#512da8'],
  [800, '#4527a0'],
  [900, '#311b92'],
]);

const INDIGO: ReadonlyMap<MaterialStep, string> = new Map([
  [50, '#e8eaf6'],
  [100, '#c5cae9'],
  [200, '#9fa8da'],
  [300, '#7986cb'],
  [400, '#5c6bc0'],
  [500, '#3f51b5'],
  [600, '#3949ab'],
  [700, '#303f9f'],
  [800, '#283593'],
  [900, '#1a237e'],
]);

const BLUE: ReadonlyMap<MaterialStep, string> = new Map([
  [50, '#ECFFFF'],
  [100, '#B6FFFF'],
  [200, '#9BE9FF'],
  [300, '#74CEFF'],
  [400, '#58BAFF'],
  [500, '#2AA5FD'],
  [600, '#0096EA'],
  [700, '#0081CF'],
  [800, '#006CB6'],
  [900, '#00569A'],
]);

const LIGHT_BLUE: ReadonlyMap<MaterialStep, string> = new Map([
  [50, '#e1f5fe'],
  [100, '#b3e5fc'],
  [200, '#81d4fa'],
  [300, '#4fc3f7'],
  [400, '#29b6f6'],
  [500, '#03a9f4'],
  [600, '#039be5'],
  [700, '#0288d1'],
  [800, '#0277bd'],
  [900, '#01579b'],
]);

const CYAN: ReadonlyMap<MaterialStep, string> = new Map([
  [50, '#e0f7fa'],
  [100, '#b2ebf2'],
  [200, '#80deea'],
  [300, '#4dd0e1'],
  [400, '#26c6da'],
  [500, '#00bcd4'],
  [600, '#00acc1'],
  [700, '#0097a7'],
  [800, '#00838f'],
  [900, '#006064'],
]);

const TEAL: ReadonlyMap<MaterialStep, string> = new Map([
  [50, '#e0f2f1'],
  [100, '#b2dfdb'],
  [200, '#80cbc4'],
  [300, '#4db6ac'],
  [400, '#26a69a'],
  [500, '#009688'],
  [600, '#00897b'],
  [700, '#00796b'],
  [800, '#00695c'],
  [900, '#004d40'],
]);

const GREEN: ReadonlyMap<MaterialStep, string> = new Map([
  [50, '#F9FFE3'],
  [100, '#E0FFC2'],
  [200, '#C1FFA0'],
  [300, '#A5FF7A'],
  [400, '#90FF5A'],
  [500, '#76F53B'],
  [600, '#63E332'],
  [700, '#4ECF92'],
  [800, '#33BB22'],
  [900, '#009714'],
]);

const LIGHT_GREEN: ReadonlyMap<MaterialStep, string> = new Map([
  [50, '#f1f8e9'],
  [100, '#dcedc8'],
  [200, '#c5e1a5'],
  [300, '#aed581'],
  [400, '#9ccc65'],
  [500, '#8bc34a'],
  [600, '#7cb342'],
  [700, '#689f38'],
  [800, '#558b2f'],
  [900, '#33691e'],
]);

const LIME: ReadonlyMap<MaterialStep, string> = new Map([
  [50, '#f9fbe7'],
  [100, '#f0f4c3'],
  [200, '#e6ee9c'],
  [300, '#dce775'],
  [400, '#d4e157'],
  [500, '#cddc39'],
  [600, '#c0ca33'],
  [700, '#afb42b'],
  [800, '#9e9d24'],
  [900, '#827717'],
]);

const YELLOW: ReadonlyMap<MaterialStep, string> = new Map([
  [50, '#fffde7'],
  [100, '#fff9c4'],
  [200, '#fff59d'],
  [300, '#fff176'],
  [400, '#ffee58'],
  [500, '#ffeb3b'],
  [600, '#fdd835'],
  [700, '#fbc02d'],
  [800, '#f9a825'],
  [900, '#f57f17'],
]);

const AMBER: ReadonlyMap<MaterialStep, string> = new Map([
  [50, '#FFFFFB'],
  [100, '#FFF3CE'],
  [200, '#FFE09B'],
  [300, '#FFCC66'],
  [400, '#FEBE41'],
  [500, '#FFB028'],
  [600, '#FBA522'],
  [700, '#F7961E'],
  [800, '#F08719'],
  [900, '#E96F12'],
]);

const ORANGE: ReadonlyMap<MaterialStep, string> = new Map([
  [50, '#fff3e0'],
  [100, '#ffe0b2'],
  [200, '#ffcc80'],
  [300, '#ffb74d'],
  [400, '#ffa726'],
  [500, '#ff9800'],
  [600, '#fb8c00'],
  [700, '#f57c00'],
  [800, '#ef6c00'],
  [900, '#e65100'],
]);

const DEEP_ORANGE: ReadonlyMap<MaterialStep, string> = new Map([
  [50, '#fbe9e7'],
  [100, '#ffccbc'],
  [200, '#ffab91'],
  [300, '#ff8a65'],
  [400, '#ff7043'],
  [500, '#ff5722'],
  [600, '#f4511e'],
  [700, '#e64a19'],
  [800, '#d84315'],
  [900, '#bf360c'],
]);

const BROWN: ReadonlyMap<MaterialStep, string> = new Map([
  [50, '#efebe9'],
  [100, '#d7ccc8'],
  [200, '#bcaaa4'],
  [300, '#a1887f'],
  [400, '#8d6e63'],
  [500, '#795548'],
  [600, '#6d4c41'],
  [700, '#5d4037'],
  [800, '#4e342e'],
  [900, '#3e2723'],
]);

const GREY: ReadonlyMap<MaterialStep, string> = new Map([
  [50, '#fafafa'],
  [100, '#f5f5f5'],
  [200, '#eeeeee'],
  [300, '#e0e0e0'],
  [400, '#bdbdbd'],
  [500, '#9e9e9e'],
  [600, '#757575'],
  [700, '#616161'],
  [800, '#424242'],
  [900, '#212121'],
]);

const BLUE_GREY: ReadonlyMap<MaterialStep, string> = new Map([
  [50, '#eceff1'],
  [100, '#cfd8dc'],
  [200, '#b0bec5'],
  [300, '#90a4ae'],
  [400, '#78909c'],
  [500, '#607d8b'],
  [600, '#546e7a'],
  [700, '#455a64'],
  [800, '#37474f'],
  [900, '#263238'],
]);

export const MATERIAL_COLOR_LIST = {
  RED,
  PINK,
  PURPLE,
  DEEP_PURPLE,
  INDIGO,
  BLUE,
  LIGHT_BLUE,
  CYAN,
  TEAL,
  GREEN,
  LIGHT_GREEN,
  LIME,
  YELLOW,
  AMBER,
  ORANGE,
  DEEP_ORANGE,
  BROWN,
  GREY,
  BLUE_GREY,
};

export const MATERIAL_COLOR_ARRAY: string[] = [
  ...RED.values(),
  ...PINK.values(),
  ...PURPLE.values(),
  ...DEEP_PURPLE.values(),
  ...INDIGO.values(),
  ...BLUE.values(),
  ...LIGHT_BLUE.values(),
  ...CYAN.values(),
  ...TEAL.values(),
  ...GREEN.values(),
  ...LIGHT_GREEN.values(),
  ...LIME.values(),
  ...YELLOW.values(),
  ...AMBER.values(),
  ...ORANGE.values(),
  ...DEEP_ORANGE.values(),
  ...BROWN.values(),
  ...GREY.values(),
  ...BLUE_GREY.values(),
];

export const FUSUS_GREEN = 'rgb(102, 189, 77)';
